module.exports = __webpack_public_path__ + "img/humanities.eaff93ba.webp";